import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { LoggingService, NotificationCenterService, SignalRHub } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NavigationService, NavigationSettings } from '@fgb/portal-component-library/src/lib/shared/services';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fgb-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.scss'],
})
export class MasterPageComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  private _destroyRef = inject(DestroyRef);
  screenType = ScreenType;
  navigationSettings: NavigationSettings;
  constructor(
    private signalRHub: SignalRHub,
    private logService: LoggingService,
    private navigationService: NavigationService,
    private notificationCenterService: NotificationCenterService
  ) {}

  ngOnInit() {
    this.signalRHub.connectionEstablished$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((connection) => {
      this.logService.debug('SignalR connection', connection);
    });
    this.notificationCenterService.fetchNotificationCenter(5).pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
        // Subscribe to navigation changes
    this.navigationService.onNavigationChanged.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((navigationSettings) => {
          this.navigationSettings = navigationSettings;
        });  
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
